declare var dr_cookiebanner_options: any

export class DatareporterHelper {
    public static showYtDatareporterConsent(className: string) {
        const placeholders = document.getElementsByClassName(className)
        for (let i = 0; i < placeholders.length; ++i) {
            placeholders[i].classList.remove("_hidden")
        }
    }

    public static reInitDatareporterPlaceholder() {
        dr_cookiebanner_options.dr_activateTags(dr_cookiebanner_options.dr_hasConsent("statistic"), dr_cookiebanner_options.dr_hasConsent("marketing"), false);
    }
}
